import { redirect } from "@remix-run/node";

const getRequestHostname = (request: Request): string => {
  const headerHost =
    request.headers.get("x-forwarded-host") ??
    request.headers.get("x-original-host") ??
    request.headers.get("host");
  const urlHost = new URL(request.url).host;
  return (headerHost ?? urlHost).split(",")[0].trim();
};

const normalizeHostname = (hostname: string): string =>
  hostname.replace(/^www\./i, "").toLowerCase();

export const domainRedirectMap: Record<string, string> = {
  "missmary.se": "se",
  "missmary.de": "de",
  "missmary.fi": "fi",
  "missmary.fr": "fr",
  "missmary.nl": "nl",
  "missmary.co.uk": "gb",
  "missmaryofsweden.dk": "dk",
  "missmary.es": "es",
  "missmary.no": "no",
};

export const applyHostnameRedirect = (request: Request) => {
  const url = new URL(request.url);
  if (url.searchParams.has("_storyblok")) {
    return null;
  }

  const pathname = url.pathname.replace(/^\/+/, "");
  if (pathname !== "") {
    return null;
  }

  const hostname = normalizeHostname(getRequestHostname(request));
  const resolvedSlug = domainRedirectMap[hostname];
  if (!resolvedSlug) {
    return null;
  }

  const queryString = url.searchParams.toString();
  const redirectTo = `/${resolvedSlug}${queryString ? `?${queryString}` : ""}`;
  return redirect(redirectTo);
};
